export const formLocalization = {
  deleteDraftTitle: {
    en: 'Are you sure you want to delete the draft?',
    nb: 'Er du sikker på at du vil slette utkastet?',
    nn: 'Er du sikker på at du vil slette utkastet?',
  },
  deleteDraftConfirmText: {
    en: 'Yes',
    nb: 'Ja',
    nn: 'Ja',
  },
  deleteDraftCancelText: {
    en: 'Cancel',
    nb: 'Avbryt',
    nn: 'Avbryt',
  },
  draftDeletionMessage: {
    en: 'Drafts will be automatically deleted 90 days after the last change.',
    nb: 'Kladder vil automatisk slettes 90 dager etter siste endring.',
    nn: 'Kladdar vil automatisk bli sletta 90 dagar etter siste endring.',
  },
  previousLabel: {
    en: 'Previous',
    nb: 'Forrige',
    nn: 'Førre',
  },
  nextLabel: {
    en: 'Next',
    nb: 'Neste',
    nn: 'Neste',
  },
  cancelLabel: {
    en: 'Cancel',
    nb: 'Avbryt',
    nn: 'Avbryt',
  },
  submitLabel: {
    en: 'Submit',
    nb: 'Send inn',
    nn: 'Send inn',
  },
  saveAndClose: {
    en: 'Save and close',
    nb: 'Lagre og lukk',
    nn: 'Lagre og lukk',
  },
  deleteDraft: {
    en: 'Delete draft',
    nb: 'Slett utkast',
    nn: 'Slett utkast',
  },
  delete: {
    en: 'Delete',
    nb: 'Slett',
    nn: 'Slett',
  },
  yes: {
    en: 'Yes',
    nb: 'Ja',
    nn: 'Ja',
  },
  no: {
    en: 'No',
    nb: 'Nei',
    nn: 'Nei',
  },
  noFilesUploaded: {
    en: 'No files',
    nb: 'Ingen filer',
    nn: 'Ingen filer',
  },
  requiredFileUploadErrorMessage: {
    en: 'You must upload a file',
    nb: 'Du må laste opp en fil',
    nn: 'Du må laste opp ei fil',
  },
  maxFileUploadErrorMessage: {
    en: 'You can only upload a maximum of {0} files',
    nb: 'Du kan bare laste opp maksimalt {0} filer',
    nn: 'Du kan berre laste opp maksimalt {0} filer',
  },
  fileUploadFailedLabel: {
    en: 'File upload failed',
    nb: 'Opplasting av fil mislyktes',
    nn: 'Opplasting av fil mislukka',
  },
  fileUploadTryAgainLabel: {
    en: 'Try again',
    nb: 'Prøv igjen',
    nn: 'Prøv igjen',
  },
  uploadLabel: {
    nb: 'Velg fil',
    nn: 'Velg fil',
    en: 'Select file',
  },
  dragAndDropText: {
    en: 'or drag and drop your files here',
    nb: 'eller dra og slipp filene dine her',
    nn: 'eller dra og slepp filene dine her',
  },
  requiredFieldErrorMessage: {
    en: 'This field is required.',
    nb: 'Dette feltet er påkrevd.',
    nn: 'Dette feltet er påkrevd.',
  },
  radioButtonRequiredErrorMessage: {
    en: 'You must choose one of the options',
    nb: 'Du må velge et av alternativene',
    nn: 'Du må velje eitt av alternativa',
  },
  checkboxGroupRequiredErrorMessage: {
    en: 'You must choose at least one option',
    nb: 'Du må velge minst ett alternativ',
    nn: 'Du må velje minst eitt alternativ',
  },
  checkboxGroupConfirmTermsAndConditions: {
    en: 'You must confirm that you have provided correct information and that you have read and understood the terms and conditions for this application.',
    nb: 'Du må bekrefte at du har oppgitt korrekte opplysninger og at du har lest og forstått betingelser og vilkår for denne søknaden.',
    nn: 'Du må bekrefte at du har oppgitt korrekte opplysningar og at du har lese og forstått betingelsar og vilkår for denne søknaden.',
  },
  maxLengthErrorMessage: {
    en: 'Cannot exceed {0} characters',
    nb: 'Kan ikke overstige {0} tegn',
    nn: 'Kan ikkje overstige {0} teikn',
  },
  counterOver: {
    en: '%d characters too many',
    nb: '%d tegn for mye',
    nn: '%d teikn for mykje',
  },
  counterUnder: {
    en: '%d characters remaining',
    nb: '%d tegn igjen',
    nn: '%d teikn igjen',
  },
  counterHint: {
    en: 'Max %d characters allowed.',
    nb: 'Maks %d tegn tillatt.',
    nn: 'Maks %d teikn tillate.',
  },
  submissionSuccessTitle: {
    en: 'Submission was successful!',
    nb: 'Innsendingen var vellykket!',
    nn: 'Innsendinga var vellukka!',
  },

  // TODO remove release of collaterals specific text
  submissionSuccessMessage: {
    en: 'Your application for {0} has been submitted. We will process your application as soon as possible and will contact you if any necessary documentation is missing. A decision will be sent once the case is decided.',
    nb: 'Din søknad om {0} er innsendt. Vi vil behandle din søknad så snart som mulig, og tar kontakt dersom nødvendig dokumentasjon mangler. Vedtak vil bli oversendt når saken er besluttet.',
    nn: 'Din søknad om {0} er sendt inn. Vi vil behandle søknaden din så snart som mogleg og tar kontakt dersom nødvendig dokumentasjon manglar. Vedtak vil bli oversendt når saka er avgjort.',
  },
  backButton: {
    en: 'Back to account overview',
    nb: 'Tilbake til kontooversikt',
    nn: 'Tilbake til kontooversikt',
  },
  submittingFormTitle: {
    en: 'Submitting form, this may take a while. Please do not close the page.',
    nb: 'Sender inn skjema, dette kan ta litt tid. Vennligst ikke lukk siden.',
    nn: 'Sender inn skjema, dette kan ta litt tid. Ver venleg og ikkje lukk sida.',
  },
  errorTitle: {
    en: 'Something went wrong',
    nb: 'Noe gikk feil',
    nn: 'Noko gjekk gale',
  },
  errorMessage: {
    en: 'Please try again. If the problem persists, you can contact support at',
    nb: 'Vennligst prøv igjen. Dersom problemet vedvarer kan du ta kontakt med support på',
    nn: 'Ver venleg og prøv igjen. Dersom problemet held fram, kan du kontakte support på',
  },
  fileTooBigError: {
    en: 'The file is too big. Please upload a smaller file and try again. If the problem persists, you can contact support.',
    nb: 'Filen er for stor. Vennligst last opp en mindre fil og prøv igjen. Dersom problemet vedvarer kan du ta kontakt med support.',
    nn: 'Filen er for stor. Ver venleg og last opp ei mindre fil og prøv igjen. Dersom problemet held fram, kan du kontakte support.',
  },
  noFileProvidedError: {
    en: 'No file provided. Please try again. If the problem persists, you can contact support at',
    nb: 'Ingen fil levert. Vennligst prøv igjen. Hvis problemet vedvarer, kan du kontakte support.',
    nn: 'Ingen fil levert. Ver venleg og prøv igjen. Dersom problemet held fram, kan du kontakte support.',
  },
  fileNotCorrectTypeError: {
    en: 'The file type is not correct. Please upload a valid file type and try again. If the problem persists, you can contact support.',
    nb: 'Filtypen er ikke korrekt. Vennligst last opp en gyldig filtype og prøv igjen. Dersom problemet vedvarer kan du ta kontakt med support.',
    nn: 'Filtypen er ikkje korrekt. Ver venleg og last opp ei gyldig filtype og prøv igjen. Dersom problemet held fram, kan du kontakte support.',
  },
  fileError: {
    en: 'An error occurred with the file. Please try again. If the problem persists, you can contact support.',
    nb: 'En feil oppstod med filen. Vennligst prøv igjen. Dersom problemet vedvarer kan du ta kontakt med support.',
    nn: 'Ein feil oppstod med fila. Ver venleg og prøv igjen. Dersom problemet held fram, kan du kontakte support.',
  },
  fileInfectedError: {
    en: 'The file seems to be infected. You may contact support if you have any questions.',
    nb: 'Filen ser ut til å være infisert. Du kan ta kontakt med support dersom du har spørsmål.',
    nn: 'Fila ser ut til å vere infisert. Du kan ta kontakt med support dersom du har spørsmål.',
  },
  fileNameInvalidError: {
    en: 'The file appears to have an invalid name. You may contact support if you have any questions.',
    nb: 'Navnet på filen du laster opp er ugyldig. Du kan ta kontakt med kundestøtte dersom du har spørsmål.',
    nn: 'Namnet på fila du lastar opp er ugyldig. Du kan ta kontakt med kundestøtte dersom du har spørsmål.',
  },

  payoutAmountRequired: {
    nb: 'Du må oppgi utbetalingsbeløp',
    nn: 'Du må oppgi utbetalingsbeløp',
    en: 'You must specify the payout amount',
  },

  payoutAmountMaxErrorMessage: {
    nb: 'Maksimalt utbetalingsbeløp er ',
    nn: 'Maksimalt utbetalingsbeløp er ',
    en: 'The maximum payout amount is ',
  },

  accountNumberFormatError: {
    nb: 'Du må oppgi et gyldig kontonummer',
    nn: 'Du må oppgi eit gyldig kontonummer',
    en: 'You must provide a valid account number',
  },
  downloadFileErrorMessage: {
    nb: 'Noe gikk galt under nedlastingen av dokumentet',
    nn: 'Noko gjekk gale under nedlastinga av dokumentet',
    en: 'Something went wrong while downloading the document',
  },
  offerLetterName: {
    nb: 'Tilbudsbrev',
    nn: 'Tilbodsbrev',
    en: 'Offer Letter',
  },
  searchValidationError: {
    nb: 'Du må velge bedrift',
    nn: 'Du må velje bedrift',
    en: 'You must select a company',
  },
  fileNotFoundError: {
    nb: 'Filen ble ikke funnet eller er allerede slettet',
    nn: 'Fila vart ikkje funnen eller er allereie sletta',
    en: 'File not found or already deleted',
  },
  unknownDeleteError: {
    nb: 'Ukjent feil, klarte ikke å slette filen',
    nn: 'Ukjend feil, klarte ikkje å slette fila',
    en: 'Unknown error, failed to delete file',
  },
  fileDeleted: {
    nb: 'Filen ble slettet',
    nn: 'Fila vart sletta',
    en: 'File deleted',
  },
  addPartnerButton: {
    nb: 'Legg til partner',
    nn: 'Legg til partnar',
    en: 'Add partner',
  },
  formCannotBeSubmittedBecauseOfFollowingErrors: {
    nb: 'Skjemaet kan ikke sendes inn på grunn av følgende feil:',
    nn: 'Skjemaet kan ikkje sendast inn på grunn av følgjande feil:',
    en: 'The form cannot be submitted due to the following errors:',
  },
  submissionSuccess: {
    nb: 'Du har sendt inn {0}',
    nn: 'Du har sendt inn {0}',
    en: 'You have submitted {0}',
  },
  submissionSuccessDateTitle: {
    en: 'Submission completed!',
    nb: 'Innsending er fullført!',
    nn: 'Innsending er fullført!',
  },

  missingDocumentationNotice: {
    en: 'We will contact you if any required documentation is missing.',
    nb: 'Vi tar kontakt med deg dersom nødvendig dokumentasjon mangler.',
    nn: 'Vi tek kontakt med deg dersom nødvendig dokumentasjon manglar.',
  },
  caseCompletionNotice: {
    en: 'When your case has been processed, you will receive an email from Innovation Norway. You can log in to My Page/Online Banking to read the response.',
    nb: 'Når saken er ferdigbehandlet vil du motta en e-post fra Innovasjon Norge. Du kan logge på Min side/Nettbank for å lese svaret.',
    nn: 'Når saka er ferdigbehandla vil du motta ein e-post frå Innovasjon Noreg. Du kan logge på Mi side/Nettbank for å lese svaret.',
  },
  viewSubmittedForm: {
    en: 'View submitted form',
    nb: 'Se innsendt skjema',
    nn: 'Sjå innsendt skjema',
  },
  backToAccountOverview: {
    en: 'Back to account overview',
    nb: 'Tilbake til kontooversikt',
    nn: 'Tilbake til kontooversikt',
  },
  submittedLabel: {
    en: 'Submitted: {0}',
    nb: 'Innsendt: {0}',
    nn: 'Innsendt: {0}',
  },
  onlyDigitsError: {
    en: 'Only digits (0-9) are allowed',
    nb: 'Bare sifre (0-9) er tillatt',
    nn: 'Berre siffer (0-9) er tillatne',
  },
  onlyNumbersError: {
    en: 'Only numbers are allowed',
    nb: 'Bare tall er tillatt',
    nn: 'Berre tal er tillatne',
  },
} as const;
